var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/* eslint-disable no-shadow */
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, } from '@material-ui/core';
import { Button, TextField, LoadingBounce } from '@michelin/acid-components';
import { isEmpty } from 'lodash';
import React, { useContext, useState, } from 'react';
import { useTranslation } from 'react-i18next';
import { CentralProviderContext, } from '../..';
import { validateEmail } from '../../helpers/validateEmail';
import { updateUser } from '../../hooks/APICallsHooks/updateUserAPI';
import { useEnqueueSnackbar } from '../../hooks/useEnqueueSnackbar';
export default function ValidateProfile() {
    var _a = useContext(CentralProviderContext), cp = _a.centralProfile, setValidateProfileFields = _a.setValidateProfileFields, setCentralProfile = _a.setCentralProfile;
    var centralProfile = cp;
    var profile = centralProfile.profile, email = centralProfile.email, uid = centralProfile.uid;
    var t = useTranslation().t;
    var firstName = profile.first_name, lastName = profile.last_name, companyName = profile.company_name, profileType = profile.profile_type;
    var snackbar = useEnqueueSnackbar();
    var _b = __read(useState({
        firstName: firstName,
        lastName: lastName,
        companyName: companyName,
        profileType: profileType,
        email: email,
    }), 2), values = _b[0], setValues = _b[1];
    var _c = __read(useState(false), 2), loading = _c[0], setLoading = _c[1];
    var handleClose = function (updatedProfile) {
        if (updatedProfile) {
            setCentralProfile(__assign(__assign({}, centralProfile), { email: updatedProfile.email, profile: updatedProfile.profile }));
        }
        setValidateProfileFields(false);
    };
    var handleInputChange = function (event) {
        var _a = event.target, name = _a.name, value = _a.value;
        setValues(function (values) {
            var _a;
            return (__assign(__assign({}, values), (_a = {}, _a[name] = value, _a)));
        });
    };
    var handleSubmit = function () {
        setLoading(true);
        var data = {
            email: values.email,
            profile_attributes: __assign(__assign(__assign({}, (profileType !== 'business' && { first_name: values.firstName || '' })), (profileType !== 'business' && { last_name: values.lastName || '' })), (profileType === 'business' && { company_name: values.companyName || '' })),
        };
        try {
            updateUser({
                data: data,
                id: uid,
            }).then(function (updatedProfile) {
                handleClose(updatedProfile);
                snackbar.enqueueMessages(t('Your profile has been updated'), 'success');
                setLoading(false);
            })
                .catch(function () {
                snackbar.enqueueMessages(t('Error updating the Application. Please try again or contact support'), 'error');
                setLoading(false);
            });
        }
        catch (error) {
            var message = error.message;
            snackbar.enqueueMessages(t(message), 'error');
            setLoading(false);
        }
    };
    return (React.createElement(Dialog, { open: true },
        React.createElement(DialogTitle, null, t('Update your account')),
        React.createElement(DialogContent, null,
            React.createElement(DialogContentText, null,
                t('Your user profile is missing required information.'), " ".concat(t('To continue logging in, please enter the following details:'))),
            profileType !== 'business' && isEmpty(firstName) && (React.createElement(TextField, { required: true, autoFocus: true, value: values.firstName, name: "firstName", label: "First Name", type: "text", onChange: handleInputChange, variant: "standard" })),
            profileType !== 'business' && isEmpty(lastName) && (React.createElement(TextField, { required: true, autoFocus: true, value: values.lastName, name: "lastName", label: "Last Name", type: "text", variant: "standard", onChange: handleInputChange })),
            profileType === 'business' && isEmpty(companyName) && (React.createElement(TextField, { required: true, autoFocus: true, value: values.companyName, name: "companyName", label: "Company Name", type: "text", variant: "standard", onChange: handleInputChange })),
            !validateEmail(email) && (React.createElement(TextField, { value: values.email, required: true, autoFocus: true, name: "email", label: "Email Address", type: "email", variant: "standard", onChange: handleInputChange }))),
        React.createElement(DialogActions, null,
            React.createElement(Button, { onClick: function () { return handleClose(null); }, color: "danger", disabled: loading }, t('Cancel')),
            React.createElement(Button, { onClick: handleSubmit }, loading ? React.createElement(LoadingBounce, { size: "0.7vh" }) : t('Update')))));
}
//# sourceMappingURL=validateProfile.js.map